var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("q-form", { ref: "editForm" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c(
              "c-card",
              {
                staticClass: "cardClassDetailForm",
                attrs: { title: "LBLBASEINFO" },
              },
              [
                _c(
                  "template",
                  { slot: "card-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: {
                                url: _vm.saveUrl,
                                isSubmit: _vm.isSave,
                                param: _vm.resultData,
                                mappingType: _vm.saveType,
                                label: "저장",
                                icon: "save",
                              },
                              on: {
                                beforeAction: _vm.saveData,
                                btnCallback: _vm.saveCallback,
                              },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isOld
                          ? _c("c-btn", {
                              attrs: { label: "삭제", icon: "remove" },
                              on: { btnClicked: _vm.deleteData },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("template", { slot: "card-detail" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                    },
                    [
                      _c("c-hazard-equip", {
                        attrs: {
                          required: true,
                          editable: _vm.editable,
                          disabled: _vm.isOld,
                          label: "유해위험기계기구",
                          name: "hhmHazardousMachineryId",
                        },
                        on: { dataChange: _vm.dataChange },
                        model: {
                          value: _vm.resultData.hhmHazardousMachineryId,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.resultData,
                              "hhmHazardousMachineryId",
                              $$v
                            )
                          },
                          expression: "resultData.hhmHazardousMachineryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                    },
                    [
                      _c("c-datepicker", {
                        attrs: {
                          required: true,
                          editable: _vm.editable,
                          default: "today",
                          label: "검사일",
                          name: "inspectionDate",
                        },
                        model: {
                          value: _vm.resultData.inspectionDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.resultData, "inspectionDate", $$v)
                          },
                          expression: "resultData.inspectionDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                    },
                    [
                      _c("c-dept", {
                        attrs: {
                          editable: _vm.editable,
                          label: "주관부서",
                          type: "edit",
                          name: "departmentDeptCd",
                        },
                        model: {
                          value: _vm.resultData.departmentDeptCd,
                          callback: function ($$v) {
                            _vm.$set(_vm.resultData, "departmentDeptCd", $$v)
                          },
                          expression: "resultData.departmentDeptCd",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                    },
                    [
                      _c("c-text", {
                        attrs: {
                          editable: _vm.editable,
                          label: "기관(검사원명)",
                          name: "inspectionAgency",
                        },
                        model: {
                          value: _vm.resultData.inspectionAgency,
                          callback: function ($$v) {
                            _vm.$set(_vm.resultData, "inspectionAgency", $$v)
                          },
                          expression: "resultData.inspectionAgency",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4",
                    },
                    [
                      _c("c-text", {
                        attrs: {
                          editable: _vm.editable,
                          label: "검사결과 상세",
                          name: "inspectionResultDetail",
                        },
                        model: {
                          value: _vm.resultData.inspectionResultDetail,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.resultData,
                              "inspectionResultDetail",
                              $$v
                            )
                          },
                          expression: "resultData.inspectionResultDetail",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12" },
                    [
                      _c("c-upload", {
                        attrs: {
                          attachInfo: _vm.attachInfo,
                          editable: _vm.editable,
                          label: "첨부파일",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-lg-12 col-md-12 col-sm-12" },
          [
            _c("c-table", {
              ref: "table3",
              attrs: {
                title: "LBL0002557",
                columns: _vm.grid.columns,
                gridHeight: _vm.grid.height,
                data: _vm.resultData.resultList,
                filtering: false,
                isExcelDown: false,
                columnSetting: false,
                usePaging: false,
                editable: _vm.editable,
                rowKey: "hazardousMachineryInspectionResultItemId",
              },
              scopedSlots: _vm._u([
                {
                  key: "suffixTitle",
                  fn: function () {
                    return [
                      _c(
                        "font",
                        {
                          staticStyle: {
                            "font-size": "0.8em",
                            "font-weight": "300",
                          },
                        },
                        [
                          _vm._v(
                            "    " +
                              _vm._s(_vm.$label("LBL0002577")) +
                              "    " +
                              _vm._s(_vm.$label("LBL0002578")) +
                              "    " +
                              _vm._s(_vm.$label("LBL0002579")) +
                              "    " +
                              _vm._s(_vm.$label("LBL0002580")) +
                              "    "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "customArea",
                  fn: function ({ props }) {
                    return [
                      props.row.testMothod
                        ? _vm._l(
                            _vm.$_.split(props.row.testMothodName, ","),
                            function (name, index) {
                              return _c(
                                "q-chip",
                                {
                                  key: index,
                                  staticClass: "q-ma-none",
                                  attrs: {
                                    outline: "",
                                    square: "",
                                    color: "orange",
                                    "text-color": "white",
                                  },
                                },
                                [_vm._v(" " + _vm._s(name + " ") + " ")]
                              )
                            }
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }